import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { AccountInformationCentreService } from '../account-information-centre.service';
@Component({
    selector: 'account-information-centre-notification-bell',
    templateUrl: './account-information-centre-notification-bell.html',
    styleUrls: ['./account-information-centre-notification-bell.scss'],
    standalone: true,
    imports: [RouterLink, NgClass, TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountInformationCentreNotificationBell extends UiComponent implements OnInit {
    protected numberOfUnreadMessages?: number;
    protected qtyBulletContent?: number | string | undefined;

    constructor(private accountInformationCentreService: AccountInformationCentreService) {
        super();
    }

    ngOnInit() {
        this.subscriptions.add(
            this.accountInformationCentreService.numberOfUnreadMessages.subscribe(el => {
                this.detectChanges();
                this.numberOfUnreadMessages = el;
                this.qtyBulletContent = this.qtyBulletContentFormat(el);
            })
        );
        super.ngOnInit();
    }

    protected qtyBulletContentFormat(el: number): number | string | undefined {
        if (!el) {
            return undefined;
        }
        if (el < 100) {
            return el;
        }
        return '';
    }
}
